<template>
  <v-card class="card-parent">
    <div class="video-upload">
      <v-file-input
        v-model="videoPath"
        class="input"
        chips
        placeholder="ویدیو مورد نظر خود را اپلود کنید"
        accept="video/mp4"
        prepend-icon="mdi-video"
      ></v-file-input>
<!--      <v-file-input-->
<!--        v-model="cover"-->
<!--        class="input"-->
<!--        chips-->
<!--        placeholder="عکس کاور ویدیو را وارد کنید."-->
<!--        accept="image/png, image/jpeg, image/bmp"-->
<!--        prepend-icon="mdi-camera"-->
<!--        v-on:change="showCover($event)"-->
<!--        v-on:click:clear="deleteCover"-->
<!--      ></v-file-input>-->
    </div>
    <div class="button">
      <v-btn :loading="videoLoading" class="button-style"  :disabled="videoPath.length===0" @click="update()">فرستادن ویدیو</v-btn>
      <v-btn  :loading="loadingDelete" v-if="videoAddress!==null"  color="red"  class="button-style"   @click="deleteVideo()">حذف ویدیو</v-btn>
    </div>
    <div class="video">
      <video  v-if="videoAddress!==null && videoAddress!==''" title=" مجتمع لوتوس مال" class="border" id="video" controls>
        <source :src="videoAddress" type="video/mp4">
      </video>
    </div>
  </v-card>
</template>

<script>
  import axios from 'axios';
  import {mapActions, mapGetters} from "vuex";
  import {putFeatures} from "../../../api/mainpage/features";
  export default {
        name: "videoUpload",
       data:()=>({
         loadingDelete:false,
         videoPath:[],
         cover:[],
         baseUrl:'',
         videoLoading:false,
         videoAddress:'',
       }),
      methods:{
          ...mapActions({
              getFeaturesReq:'featuresStore/fetchFeatures',
              snackBarAction:'snackBar/snackBarAction'
            }),
        showCover(e)
        {
          if(e) {
            this.coverImage = URL.createObjectURL(e)
          }
        },
        deleteCover()
        {
          this.coverImage=''
        },
        async deleteVideo(){
            this.loadingDelete = true
            let params= {
              videoPath: "0",
              id:this.originalFeatures[0].id
            }
          try {
            await putFeatures(params,this.originalFeatures[0].id)
            this.getFeaturesReq()
            this.videoAddress = ""
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
          }catch (e) {
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          }
          this.loadingDelete = false
        },
        async update(){
          this.videoLoading = true
          const url = this.baseUrl+'/MainPage/LotusPropVideo/Post';
          const formData = new FormData();
          formData.append('file',this.videoPath)
          for (var [key, value] of formData.entries()) {
            console.log(key, value);
          }
          const config = {
            headers: {
              'content-type': 'multipart/form-data',
              "Authorization": "Bearer " + localStorage.getItem('lotusToken'),
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
              "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
            }
          }
          try {
            await axios.post(url, formData, config)
            await this.getFeaturesReq()
            this.videoAddress = this.baseUrl + this.originalFeatures[0].videoPath
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
          }catch (e) {
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          }
          this.videoLoading = false
        }
      },
     async mounted() {
        this.baseUrl = process.env.VUE_APP_BASE_URL
        await  this.getFeaturesReq()
      },
    computed: {
      ...mapGetters({
        originalFeatures: 'featuresStore/get_features',
      })
    },
    watch:{
          originalFeatures(){
            if( this.originalFeatures[0].videoPath!==null) {
              this.videoAddress = this.baseUrl + this.originalFeatures[0].videoPath
            }
            else{
              this.videoAddress = null
            }
          }
    }
  }
</script>

<style scoped>
  .card-parent{
    width: 85%;
    margin: 0 auto;
  }
  .video-upload{
    padding: 50px 50px 20px;
  }
  .button{
    display: flex;
    flex-direction: row-reverse;
    align-self: flex-end;
    margin-top: 20px;
    padding: 0 50px 20px;
  }
  .button-style{
    width: 91px;
  }
  .video{
    display: flex;
    margin-top: 20px;
    justify-content: center;
  }
  #video{
    width: 350px;
    height: 250px;
    margin-bottom: 30px;
  }
</style>
